<script lang="ts" setup>
export interface ServiceCardProps {
    service: Service
}

const props = defineProps<ServiceCardProps>()

const phoneNumbers = computed((): PhoneNumber[] => {
    return props.service.phone_numbers.map((item: PhoneNumber): PhoneNumber => {
        const href =
            item.contact_type === 'tel'
                ? `tel:${item.number.international_format}`
                : item.url

        return {
            href,
            ...item,
        }
    })
})

const { data, sendEvent } = useTracker()

const handleClick = (phoneNumber?: string) => {
    if (phoneNumber) {
        sendEvent({
            data: {
                ...data,
                title: props.service.title,
                click: phoneNumber,
            },
        })
    }
}
</script>

<template>
  <article
    class="rounded px-2 py-8 px-md-4 py-md-12 bg-white box-shadow-1 h-100 text-start text-sm-center"
  >
    <img
      :src="props.service.icon.path"
      width="26"
      height="26"
      loading="lazy"
      decoding="async"
      alt=""
      class="d-block mx-sm-auto mb-2 mb-md-3"
    >

    <h3
      class="fs-bigger mb-1"
      :class="{
        'mb-4': !props.service.description,
      }"
    >
      {{ props.service.title }}
    </h3>

    <p
      v-if="props.service.description"
      class="fs-small mb-2 mb-sm-5"
    >
      {{ props.service.description }}
    </p>

    <a
      v-for="(phoneNumber, phoneNumberIndex) in phoneNumbers"
      :key="`assistance-service-number-${phoneNumberIndex}`"
      :href="phoneNumber.href"
      class="d-block text-secondary"
      :class="{
        'mb-1':
          phoneNumberIndex < props.service.phone_numbers.length - 1,
      }"
      @click="
        () =>
          handleClick(
            phoneNumber.number.international_format ||
              phoneNumber.url
          )
      "
    >
      {{ phoneNumber.number.international_format || phoneNumber.url }}
    </a>

    <p class="mt-2">
      {{ props.service.opening_hours }}
    </p>
  </article>
</template>
